import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import isEmpty from 'lodash/isEmpty'
import { licenseeClearState, licenseeDelete } from 'reducers/licensee/reducer'
import ConfirmDialog from 'components/common/Popup/ConfirmDialog'
import messages from './translate'
import LicenseeItem from './LicenseeItem'
import LicenseeList from './LicenseeList'

function Licensee(props) {
  const {
    match: {
      params: { id },
    },
    licenseeClearState: licenseeClear,
    intl: { formatMessage },
    licenseeDelete,
  } = props
  const LicenseeContent = id ? LicenseeItem : LicenseeList
  const [openDialog, setOpenDialog] = useState(false)
  const [confirmParams, setConfirmParams] = useState({})

  useEffect(
    () => () => {
      licenseeClear()
    },
    [],
  )

  const onConfirmActionDialog = () => {
    if (!isEmpty(confirmParams)) {
      licenseeDelete(confirmParams)
    }

    setOpenDialog(false)
  }

  return (
    <div className="content">
      <LicenseeContent
        setOpenDialog={setOpenDialog}
        setConfirmParams={setConfirmParams}
        {...props}
      />
      <ConfirmDialog
        open={openDialog}
        cancel={{
          color: 'default',
          variant: 'outlined',
          customText: formatMessage(messages.cancel),
        }}
        onClose={() => setOpenDialog(false)}
        onConfirmAction={onConfirmActionDialog}
        title={formatMessage(messages.removeLicensee)}
        message={formatMessage(messages.deleteLicenseeMessage)}
      />
    </div>
  )
}

Licensee.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  licenseeClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  licenseeClearState,
  licenseeDelete,
})(injectIntl(Licensee))
